export default __webpack_public_path__ + "static/image-2-736f515c3ad509c2f4606017d0fb7627.jpg";